import request from "@/utils/request";
// 研报-首页推荐列表
export function recommedReportList(params) {
  return request({
    url: "/researchReport/recommendList",
    method: "get",
    params,
  });
}
// 研报合集-列表
export function reportList(params) {
  return request({
    url: "/researchReportCollection/list",
    method: "get",
    params,
  });
}
// 研报合集-详情
export function reportDetail(params) {
  return request({
    url: "/researchReportCollection/detail",
    method: "get",
    params,
  });
}
// 研报信息-列表
export function researchList(params) {
  return request({
    url: "/researchReport/list",
    method: "get",
    params,
  });
}
//file 详情
export function fileDetail(params) {
  return request({
    url: "/researchReport/detail",
    method: "get",
    params,
  });
}
// file 下载
export function fileDolad(params) {
  return request({
    url: "/check/researchReport/download",
    method: "get",
    params,
  });
}

// 获取私有链接去下载-监听二维码过期时间
export function getPrivateUrl(params) {
  return request({
    url: "/fileStorage/getPrivateUrl",
    method: "get",
    params,
  });
}

// 获取私有链接-下载-监听url是否返回
export function getUrlAfterCan(params) {
  return request({
    url: "/check/researchReport/downloadAfterScan",
    method: "get",
    params,
  });
}
// 我的下载列表
export function getMyloadList(params) {
  return request({
    url: "/check/researchReportDownloadRecord/list",
    method: "get",
    params,
  });
}
